import { useRecoveryAccountContext } from "../../Contexts/RecoveryAccountContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Button from "../../Components/Button";
import { useState, useEffect } from "react";

const RecoveryHotline = () => {
  const [isMobileView, setIsMobileView] = useState(false);
  const [copiedState, setCopiedState] = useState(null);
  const { navigate } = useRecoveryAccountContext();

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 640);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleAction = (phoneNumber) => {
    if (isMobileView) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      navigator.clipboard.writeText(phoneNumber).then(() => {
        setCopiedState(phoneNumber);
        setTimeout(() => {
          setCopiedState(null);
        }, 3000);
      });
    }
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="p-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer "
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Recover account
            </div>
          </div>

          <div className="p-4">
            <div className="text-[#1F2328] text-2xl font-bold">
              Maxicare hotline
            </div>

            <div className="text-[#60656D] mt-2 mb-2">
              Use a landline phone or a mobile device with good signal strength
              and dial the following number:
            </div>

            <div className="flex flex-col mt-2">
              <div className="w-full h-14 border border-[#E3E4E5] rounded-md p-2 flex flex-col justify-center">
                <div className="flex items-center justify-between ml-2">
                  <div>+632 8582 1900 (PLDT)</div>
                  <div className="ml-auto">
                    <Button
                      className={`h-7 transition ease-in-out delay-75 hover:scale-105 border rounded-md p-2 flex items-center cursor-pointer ${
                        isMobileView ? "bg-[#E7EEFA]" : "bg-transparent"
                      }`}
                      onClick={() => handleAction("+632 8582 1900")}
                    >
                      {isMobileView ? (
                        <span className="bg-[#E7EEFA] text-[#0947AB] text-sm font-bold ml-1">
                          Call
                        </span>
                      ) : (
                        <>
                          {copiedState === "+632 8582 1900" ? null : (
                            <ContentCopyIcon
                              sx={{ color: "#60656D" }}
                              fontSize="small"
                            />
                          )}
                          <span className="text-[#60656D] text-sm font-bold ml-1">
                            {copiedState === "+632 8582 1900"
                              ? "Copied!"
                              : "Copy"}
                          </span>
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </div>

              <div className="w-full h-14 border border-[#E3E4E5] rounded-md p-2 flex flex-col justify-center mt-3">
                <div className="flex items-center justify-between ml-2">
                  <div>+632 7798 7777 (GLOBE)</div>
                  <div className="ml-auto">
                    <Button
                      className={`h-7 transition ease-in-out delay-75 hover:scale-105 border rounded-md p-2 flex items-center cursor-pointer ${
                        isMobileView ? "bg-[#E7EEFA]" : "bg-transparent"
                      }`}
                      onClick={() => handleAction("+632 7798 7777")}
                    >
                      {isMobileView ? (
                        <span className="bg-[#E7EEFA] text-[#0947AB] text-sm font-bold ml-1">
                          Call
                        </span>
                      ) : (
                        <>
                          {copiedState === "+632 7798 7777" ? null : (
                            <ContentCopyIcon
                              sx={{ color: "#60656D" }}
                              fontSize="small"
                            />
                          )}
                          <span className="text-[#60656D] text-sm font-bold ml-1">
                            {copiedState === "+632 7798 7777"
                              ? "Copied!"
                              : "Copy"}
                          </span>
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4 mb-3">
          <Button
            className="h-12 w-full transition ease-in-out delay-75 rounded-xl text-white"
            onClick={() => navigate("/login")}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RecoveryHotline;
